module.exports = __webpack_public_path__ + "static/media/link.b48e8e17.svg";